angular.module('ihestiaWidgets.policyDetails')
  .factory('owuModalHelper', [function() {
    var OwuModalHelper = function() {
      this.owus = [];
    };

    return new OwuModalHelper();
  }]);
